export default __webpack_public_path__ + "static/media/GaneshJi.a3632cb5.png";